import React from "react";
import WorkImg from "../assets/housebazar.png";
import ProjectsCard from "./ProjectsCard";
import xpenser from "../assets/xpenser.jpg";
import movie from "../assets/movie.png";
import clothshop from "../assets/clothingshop.jpg";
import paytm from "../assets/paytm-img.jpg";
import shopify from "../assets/shopify.jpg";

const Projects = () => {
  const prodData = [
    {
      name: "Crwn-clothing shop",
      img: `${clothshop}`,
      live: "https://crwn-clothingshop.netlify.app/",
      github: "https://github.com/RishabhSingh12/crwn-clothing.git",
    },
    {
      name: "House Bazaar",
      img: `${WorkImg}`,
      live: "https://house-bazar.netlify.app/",
      github: "https://github.com/RishabhSingh12/House-Bazar.git",
    },
    {
      name: "Entertainment Hub",
      img: `${movie}`,
      live: "https://entertainment-hub1a.netlify.app/",
      github: "https://github.com/RishabhSingh12/Entertainment-Hub.git",
    },
    {
      name: "Xpense Manager",
      img: `${xpenser}`,
      live: "https://xpenser-1.netlify.app/",
      github: "https://github.com/RishabhSingh12/Xpenser.git",
    },

    {
      name: "PayZm Static Clone",
      img: `${paytm}`,
      live: "https://payzm-clone-90.netlify.app/",
      github: "https://github.com/RishabhSingh12/Payzm_Clone",
    },
    {
      name: "Shopify static clone",
      img: `${shopify}`,
      live: "https://shopify-clone-rish.vercel.app/",
      github: "https://github.com/RishabhSingh12/Shopify-Clone",
    },
  ];

  return (
    <div name="work" className="w-full md:h-screen text-gray-300 bg-[#0a192f]">
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600">
            Projects
          </p>
          <p className="py-6"> Check out some of my recent projects</p>
        </div>

        {/* Container */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5">
          {prodData.map((ele, idx) => (
            <ProjectsCard data={ele} key={idx} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
